 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Login":"Login","adminRegister":"adminRegister","calendar~settings~settingsCompany~settingsProducts":"calendar~settings~settingsCompany~settingsProducts","calendar~serviceBookAppointment~settingsProducts":"calendar~serviceBookAppointment~settingsProducts","calendar~settingsProducts":"calendar~settingsProducts","calendar":"calendar","settings~settingsProducts":"settings~settingsProducts","settingsProducts":"settingsProducts","settings~settingsCompany":"settings~settingsCompany","settingsCompany":"settingsCompany","settings":"settings","callback":"callback","productsCompany~serviceBookAppointment":"productsCompany~serviceBookAppointment","serviceBookAppointment":"serviceBookAppointment","productsCompany":"productsCompany","dashboard":"dashboard","forbidden":"forbidden","forgotPassword":"forgotPassword","home":"home","not-found":"not-found","notifications":"notifications","products":"products","productsCategories":"productsCategories","productsCategoriesCategory":"productsCategoriesCategory","productsProduct~settingsProductsCreate":"productsProduct~settingsProductsCreate","productsProduct":"productsProduct","settingsProductsCreate":"settingsProductsCreate","resetPassword":"resetPassword","serviceCategories":"serviceCategories","serviceCategoryDetails":"serviceCategoryDetails","services":"services","userRegister":"userRegister","userVerifyAccount":"userVerifyAccount"}[chunkId]||chunkId) + "." + {"Login":"6a93d7b7","adminRegister":"96a09a2a","calendar~settings~settingsCompany~settingsProducts":"b2e894bf","calendar~serviceBookAppointment~settingsProducts":"2ab201f6","calendar~settingsProducts":"3a52736b","calendar":"ebbb532d","settings~settingsProducts":"d669152a","settingsProducts":"459689d5","settings~settingsCompany":"6c048867","settingsCompany":"5473a5f1","settings":"b46bbfbd","callback":"97c5f825","chunk-026cbb70":"6dacdea1","chunk-2d2138d7":"06e2b634","chunk-3b382cfe":"2cb0ada9","productsCompany~serviceBookAppointment":"6c074280","serviceBookAppointment":"c7fe834e","chunk-076b0bf4":"19946cf8","productsCompany":"294e24e4","chunk-4bf061d4":"bf41ec82","dashboard":"283582e0","forbidden":"9c2fd43f","forgotPassword":"974c791e","home":"9afc3ec4","not-found":"04f600a9","notifications":"1669b129","products":"67124135","productsCategories":"a521505c","productsCategoriesCategory":"28d47ab0","productsProduct~settingsProductsCreate":"5823f56d","productsProduct":"617ed9c5","settingsProductsCreate":"93da5a66","resetPassword":"65db90b2","serviceCategories":"8833dfdd","serviceCategoryDetails":"b2dc4c08","services":"0012f99b","userRegister":"7b064b51","userVerifyAccount":"4f6a540c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Login":1,"adminRegister":1,"calendar~settings~settingsCompany~settingsProducts":1,"calendar~serviceBookAppointment~settingsProducts":1,"calendar~settingsProducts":1,"calendar":1,"settings~settingsProducts":1,"settingsProducts":1,"settings~settingsCompany":1,"settingsCompany":1,"settings":1,"chunk-026cbb70":1,"chunk-3b382cfe":1,"serviceBookAppointment":1,"chunk-076b0bf4":1,"productsCompany":1,"chunk-4bf061d4":1,"dashboard":1,"forgotPassword":1,"home":1,"not-found":1,"notifications":1,"products":1,"productsCategories":1,"productsCategoriesCategory":1,"productsProduct~settingsProductsCreate":1,"productsProduct":1,"settingsProductsCreate":1,"resetPassword":1,"serviceCategories":1,"serviceCategoryDetails":1,"services":1,"userRegister":1,"userVerifyAccount":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Login":"Login","adminRegister":"adminRegister","calendar~settings~settingsCompany~settingsProducts":"calendar~settings~settingsCompany~settingsProducts","calendar~serviceBookAppointment~settingsProducts":"calendar~serviceBookAppointment~settingsProducts","calendar~settingsProducts":"calendar~settingsProducts","calendar":"calendar","settings~settingsProducts":"settings~settingsProducts","settingsProducts":"settingsProducts","settings~settingsCompany":"settings~settingsCompany","settingsCompany":"settingsCompany","settings":"settings","callback":"callback","productsCompany~serviceBookAppointment":"productsCompany~serviceBookAppointment","serviceBookAppointment":"serviceBookAppointment","productsCompany":"productsCompany","dashboard":"dashboard","forbidden":"forbidden","forgotPassword":"forgotPassword","home":"home","not-found":"not-found","notifications":"notifications","products":"products","productsCategories":"productsCategories","productsCategoriesCategory":"productsCategoriesCategory","productsProduct~settingsProductsCreate":"productsProduct~settingsProductsCreate","productsProduct":"productsProduct","settingsProductsCreate":"settingsProductsCreate","resetPassword":"resetPassword","serviceCategories":"serviceCategories","serviceCategoryDetails":"serviceCategoryDetails","services":"services","userRegister":"userRegister","userVerifyAccount":"userVerifyAccount"}[chunkId]||chunkId) + "." + {"Login":"5fb3b43e","adminRegister":"8f52da06","calendar~settings~settingsCompany~settingsProducts":"d827ec14","calendar~serviceBookAppointment~settingsProducts":"fc5d71ea","calendar~settingsProducts":"4107fbae","calendar":"e9c4b096","settings~settingsProducts":"9ec567ec","settingsProducts":"e8925c47","settings~settingsCompany":"abd89ac3","settingsCompany":"d172a70e","settings":"5aaf7a42","callback":"31d6cfe0","chunk-026cbb70":"4e624561","chunk-2d2138d7":"31d6cfe0","chunk-3b382cfe":"80d8a5b6","productsCompany~serviceBookAppointment":"31d6cfe0","serviceBookAppointment":"066514f9","chunk-076b0bf4":"043302f2","productsCompany":"ac9e8d54","chunk-4bf061d4":"e73dd524","dashboard":"d3b844b0","forbidden":"31d6cfe0","forgotPassword":"4fca1cc6","home":"302b7edb","not-found":"17c65aee","notifications":"a8f99661","products":"0b00475e","productsCategories":"610460ad","productsCategoriesCategory":"9314a41f","productsProduct~settingsProductsCreate":"43d6b8c1","productsProduct":"77cbf509","settingsProductsCreate":"8521c7ab","resetPassword":"337d6eea","serviceCategories":"6ea1dba1","serviceCategoryDetails":"563659ce","services":"cdedfde7","userRegister":"67bb2a49","userVerifyAccount":"6e815065"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
